import { create } from 'zustand';
import { NexoyaOrg, NexoyaTenantUiCustomization } from '../types';
import type { TenantBrand } from '../entitlements/tenant';

export const DEFAULT_UI_CUSTOMIZATION_FALLBACK: Partial<NexoyaTenantUiCustomization> = {
  helpPageUrl: 'https://nexoya.com/help',
  onboardingMail: 'onboarding@nexoya.io',
  supportMail: 'support@nexoya.io',
};

type OrganizationStore = {
  organization: NexoyaOrg | null;
  setOrganization: (organization: NexoyaOrg | null) => void;
  /**
   * `null` means unresolved — the team query hasn't answered for THIS team yet. Not
   * "white-label". Published by `useTenantSync`; derived by `tenantBrandForTeam`.
   */
  tenantBrand: TenantBrand | null;
  setTenantBrand: (tenantBrand: TenantBrand | null) => void;
  customization: NexoyaTenantUiCustomization;
  setCustomization: (customization: NexoyaTenantUiCustomization) => void;
  getHelpPageUrl: () => string;
};

const useOrganizationStore = create<OrganizationStore>((set, get) => ({
  organization: null,
  setOrganization: (organization) => set({ organization }),
  tenantBrand: null,
  setTenantBrand: (tenantBrand) => set({ tenantBrand }),
  customization: {},
  setCustomization: (customization) => set({ customization }),
  // Single source for every help entry point: a tenant may send a partial
  // customization, and an empty url renders a dead <button> instead of a link.
  getHelpPageUrl: () => get().customization?.helpPageUrl || DEFAULT_UI_CUSTOMIZATION_FALLBACK.helpPageUrl,
}));

export default useOrganizationStore;
